import { render, staticRenderFns } from "./BanList.vue?vue&type=template&id=52096a70&"
import script from "./BanList.vue?vue&type=script&lang=js&"
export * from "./BanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports